import * as React from "react";
import * as styles from "./styles";

interface IProps {
  type?: "normal" | "headline" | "subheading" | "subsubheading";
  color?: "normal" | "grey" | "black" | "red";
  children?: React.ReactNode;
}

const Typography: React.FC<IProps> = ({ type, children, color }) => (
  <div className={`${styles.text} ${styles[type]} ${styles.color[color]}`}>{children}</div>
);

export default Typography;
